// extracted by mini-css-extract-plugin
export default {"root":"footer__root__NMEMN","poweredBy":"footer__poweredBy__o3X8m","logo":"footer__logo__OnpKn"};